import * as Sentry from '@sentry/react'
import type { ParsedSyncError } from './syncErrors'

export function reportSyncError(context: {
  kind: 'pickup' | 'delivery'
  draftId?: number
  parsed: ParsedSyncError
  draftItems?: { pickup_record_item_id: number; kilos: number }[]
}): void {
  console.error('[sync-error]', {
    kind: context.kind,
    draftId: context.draftId,
    status: context.parsed.status,
    fieldErrors: context.parsed.fieldErrors,
    technicalDetail: context.parsed.technicalDetail,
  })

  const err = new Error(context.parsed.technicalDetail)
  err.name = `SyncError[${context.kind}]`
  Sentry.captureException(err, {
    tags: { 'sync.kind': context.kind },
    contexts: {
      sync: {
        draftId: context.draftId ?? null,
        status: context.parsed.status ?? null,
        fieldErrors: context.parsed.fieldErrors ?? null,
        draftItems: context.draftItems ? JSON.stringify(context.draftItems) : null,
      },
    },
  })
}
